<template>
  <div style="height: 100%;">
    <div :style="MyStyle(2)">
      <Split v-model="split_setting2" mode="vertical">
        <div slot="top" style="height: 100%">
          <BaseContainer style="padding: 0 0 2px 0; height: 100%">
            <slot name="top" />
          </BaseContainer>
        </div>
        <div slot="bottom" style="height: 100%">
          <BaseContainer style="padding: 2px 0 0 0; height: 100%">
            <slot name="bottom" />
          </BaseContainer>
        </div>
        <div slot="trigger" class="customerCss2 text-center">
          <div class="ivu-split-trigger">
            <b-button variant="primary" class="mr-1" style="
                  width: 25px;
                  margin-top: -20px;
                  height: 16px;
                  padding: 0;
                  /* font-size:6px; */
                  /* background-color: #c0c4cc; */
                  border-color: #c0c4cc;
                " size="sm" @click="uptable2">
              <i class="el-icon-upload2"></i>
            </b-button>
            <b-button variant="primary" style="
                  width: 25px;
                  margin-left:0.8rem;
                  margin-top: -20px ;
                  height: 16px;
                  padding: 0;
                  /* font-size:6px; */
                  /* background-color: #c0c4cc; */
                  border-color: #c0c4cc;
                " size="sm" @click="splittable2">=</b-button>
            <b-button class="ml-1" variant="primary" style="
                  width: 25px;
                  margin-top: -20px;
                  margin-left:1rem !important;
                  height: 16px;
                  padding: 0;
                  /* font-size:6px; */
                  /* background-color: #c0c4cc; */
                  border-color: #c0c4cc;
                " size="sm" @click="downtable2">
              <i class="el-icon-download"></i>
            </b-button>
          </div>

        </div>
      </Split>
    </div>
  </div>
</template>

<script>
import { Split } from "view-design";
import "view-design/dist/styles/iview.css";
import BaseContainer from "../BaseContainer";

export default {
  components: {
    BaseContainer,
    Split,
  },
  props: {
    layout: { type: Number, default: () => 12 },
    split_setting: { type: Number, default: () => 0.6 },
  },
  data() {
    return {
      split_setting1: 0.4,
      split_setting2: this.split_setting,
    };
  },
  computed: {
    MyHeight() {
      return this.$root.GetBasePanelHeight;
    },
  },
  methods: {
    MyStyle(position) {
      if (this.layout === 12) {
        if (position === 1) {
          return "padding: 0 2px 0 0; height: 100%";
        } else {
          return "padding: 0 0 0 2px; height: 100%";
        }
      }
    },
    uptable2() {
      this.split_setting2 = 0.25;
    },
    downtable2() {
      this.split_setting2 = 0.75;
    },
    splittable2() {
      this.split_setting2 = 0.6;
    },
  },

};
</script>

<style>
.customerCss2 {
  cursor: row-resize;
  height: 6px;
  width: 100%;
  /* background: #f8f8f9; */
  border-left: none;
  border-right: none;
}

.customerCss2 .ivu-split-trigger {
  height: 6px;
}
</style>
